import React from 'react';
import './App.scss';
import data from './data/questions.js'
//import cardStates from './data/cardStates.js'
//import Card from './components/Card.js';


class App extends React.Component {

  state = {
    boardScore: 0,
    team1: 0,
    team2: 0,
    questions: data.questions,
    currentQ: 0,
    currentQuestion: null,
    isVisible: false,
    card0: false,
    card1: false,
    card2: false,
    card3: false,
    card4: false,
    card5: false,
    card6: false,
    card7: false,
  }

  componentDidMount() {
    this.setState({
      currentQuestion: this.state.questions[this.state.currentQ]
    })
  }

  updateBoardScore = (value) => {
    this.animateValue("board-score", this.state.boardScore, this.state.boardScore + value, 1000);
    this.setState({
      boardScore: this.state.boardScore + value
    });
  }

  awardTeam = (team) => {
    if (this.state.boardScore === 0) {
      return;
    }
    if (team === 1) {
      let newScore = this.state.team1 + this.state.boardScore;
      this.animateValue("board-score", this.state.boardScore, 0, 1000);
      this.animateValue("team1", this.state.team1, newScore, 1000);
      this.setState({
        team1: newScore,
        boardScore: 0,
        card1: true,
        card0: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        card6: true,
        card7: true,
      })

    } else if (team === 2) {
      let newScore = this.state.team2 + this.state.boardScore;
      this.animateValue("board-score", this.state.boardScore, 0, 1000);
      this.animateValue("team2", this.state.team2, newScore, 1000);
      this.setState({
        team2: newScore,
        boardScore: 0,
        card0: true,
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        card6: true,
        card7: true,
      })
    }
  }

  animateValue = (id, start, end, duration) => {
    var range = end - start;
    var current = start;
    var increment = end > start ? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = document.getElementById(id);
    var timer = setInterval(function () {
      current += increment;
      obj.innerText = current;
      if (current === end) {
        clearInterval(timer);
      }
    }, stepTime);
  }

  newQuestion = () => {
    let newQ = this.state.currentQ + 1;
    this.setState({
      currentQ: newQ,
      currentQuestion: this.state.questions[this.state.currentQ],
      card0: false,
      card1: false,
      card2: false,
      card3: false,
      card4: false,
      card5: false,
      card6: false,
      card7: false,
    })
  }

  endGame = () => {
    let msg = ""
    if (this.state.team1 > this.state.team2) {
      msg = "Winner is team 1!!!"
    } else if (this.state.team1 < this.state.team2) {
      msg = "Winner is team 2!!!"
    } else {
      msg = "Tie game!!!"
    }
    window.alert(msg);
  }

  flipHandler = (i) => {
    if (i === 0) {
      let flip = !this.state.card0;
      this.setState({
        card0: flip
      })
      let value = 0;
      (!this.state.card0) ? value = this.state.currentQuestion.answers[0][1] : value = this.state.currentQuestion.answers[0][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 1) {
      let flip = !this.state.card1;
      this.setState({
        card1: flip
      })
      let value = 0;
      (!this.state.card1) ? value = this.state.currentQuestion.answers[1][1] : value = this.state.currentQuestion.answers[1][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 2) {
      let flip = !this.state.card2;
      this.setState({
        card2: flip
      })
      let value = 0;
      (!this.state.card2) ? value = this.state.currentQuestion.answers[2][1] : value = this.state.currentQuestion.answers[2][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 3) {
      let flip = !this.state.card3;
      this.setState({
        card3: flip
      })
      let value = 0;
      (!this.state.card3) ? value = this.state.currentQuestion.answers[3][1] : value = this.state.currentQuestion.answers[3][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 4) {
      let flip = !this.state.card4;
      this.setState({
        card4: flip
      })
      let value = 0;
      (!this.state.card4) ? value = this.state.currentQuestion.answers[4][1] : value = this.state.currentQuestion.answers[4][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 5) {
      let flip = !this.state.card5;
      this.setState({
        card5: flip
      })
      let value = 0;
      (!this.state.card5) ? value = this.state.currentQuestion.answers[5][1] : value = this.state.currentQuestion.answers[5][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 6) {
      let flip = !this.state.card6;
      this.setState({
        card6: flip
      })
      let value = 0;
      (!this.state.card6) ? value = this.state.currentQuestion.answers[6][1] : value = this.state.currentQuestion.answers[6][1] * (-1);
      this.updateBoardScore(value)
    } else if (i === 7) {
      let flip = !this.state.card7;
      this.setState({
        card7: flip
      })
      let value = 0;
      (!this.state.card7) ? value = this.state.currentQuestion.answers[7][1] : value = this.state.currentQuestion.answers[7][1] * (-1);
      this.updateBoardScore(value)
    }
  }

  createBlankCard = () => {
    return <div className="card-holder empty"><div></div></div>
  }

  createCard0 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card0 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(0) }}>
          {!this.state.card0 ?
            (
              <div className="front">
                <span className="DBG" >1</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[0][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[0][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )
  }

  createCard1 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card1 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(1) }}>
          {!this.state.card1 ?
            (
              <div className="front">
                <span className="DBG" >2</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[1][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[1][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )
  }

  createCard2 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card2 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(2) }}>
          {!this.state.card2 ?
            (
              <div className="front">
                <span className="DBG" >3</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[2][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[2][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )
  }

  createCard3 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card3 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(3) }}>
          {!this.state.card3 ?
            (
              <div className="front">
                <span className="DBG" >4</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[3][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[3][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )

  }

  createCard4 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card4 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(4) }}>
          {!this.state.card4 ?
            (
              <div className="front">
                <span className="DBG" >5</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[4][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[4][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )

  }

  createCard5 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card5 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(5) }}>
          {!this.state.card5 ?
            (
              <div className="front">
                <span className="DBG" >6</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[5][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[5][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )

  }

  createCard6 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card6 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(6) }}>
          {!this.state.card6 ?
            (
              <div className="front">
                <span className="DBG" >7</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[6][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[6][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )

  }

  createCard7 = () => {
    return (
      <div className="card-holder">
        <div className= //"card"
          {
            this.state.card7 ? "card is-flipped" : "card"
          }
          onClick={() => { this.flipHandler(7) }}>
          {!this.state.card7 ?
            (
              <div className="front">
                <span className="DBG" >8</span>
              </div>
            ) : (
              <div className="back DBG"  >
                <span>{this.state.currentQuestion.answers[7][0]}</span>
                <b className="LBG">{this.state.currentQuestion.answers[7][1]}</b>
              </div>
            )
          }
        </div>
      </div>
    )

  }

  render() {
    return (
      <>
        {
          (!this.state.currentQuestion) ? null : (
            <div className="game-board">

              <div className="game-board__score score" id="board-score">{this.state.boardScore}</div>
              <div className="game-board__score score" id="team1">{this.state.team1}</div>
              <div className="game-board__score score" id="team2">{this.state.team2}</div>

              <div className="question-holder">
                <span className="question">{this.state.currentQuestion.question}</span>
              </div>

              <div className="col-holder">
                {/* <div className='col1'> */}
                {
                  this.createCard0()
                } {
                  this.createCard1()
                } {
                  (this.state.currentQuestion.answers.length < 3) ? this.createBlankCard() : this.createCard2()
                } {
                  (this.state.currentQuestion.answers.length < 4) ? this.createBlankCard() : this.createCard3()
                }

                {/* </div>  */}
                {
                  (this.state.currentQuestion.answers.length < 5) ? this.createBlankCard() : this.createCard4()
                } {
                  (this.state.currentQuestion.answers.length < 6) ? this.createBlankCard() : this.createCard5()
                } {
                  (this.state.currentQuestion.answers.length < 7) ? this.createBlankCard() : this.createCard6()
                } {
                  (this.state.currentQuestion.answers.length < 8) ? this.createBlankCard() : this.createCard7()
                }

                {/* <div className='col2'> */}
                {/* </div> */}

              </div>  {/* end of col-holder */}

              <div className="game-board__button-holder">
                <div className="game-board__middle-wrapper">
                  <button className="game-board__button game-board__button--team-1" id="award-team-1" onClick={() => { this.awardTeam(1) }}>Award Team 1</button>
                  <button className="game-board__button" id="new-question" onClick={() => { this.newQuestion() }}>New Question</button>
                  <button className="game-board__button game-board__button--team-2" id="award-team-2" onClick={() => { this.awardTeam(2) }}>Award Team 2</button>
                </div>
                <button className="game-board__button" id="end-game" onClick={() => { this.endGame() }}>End Game</button>
              </div>
            </div >
          )
        }
        {
          (this.state.currentQ > this.state.questions.length) ? this.endGame() : null
        }
      </>
    );
  }
}

export default App;

